import React, { useEffect, useState } from "react";
import { Input, Modal, Checkbox, Spin } from "antd";
import axios from "axios";
import { DatePicker } from "antd";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import Apiurl from "../../Apiurl";
import { Tabhelper } from "../../Helper/Tabhelper";
import Select from 'react-select'
import { useParams } from "react-router-dom";

const { RangePicker } = DatePicker;

export default function Unassigned() {
    const [jsonList, setJsonList] = useState([]);
    const apiurl = Apiurl();
    const { user } = useParams();

    const [data, setData] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [assignFilter, setAssignFilter] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null);

    const [showAssignModal, setShowAssignModal] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState([]);
    const [unassignedCount, setUnassignedCount] = useState(0);
    const [assignPlan, setAssignPlan] = useState([]);
    const [schoolList, setSchoolList] = useState([]);
    const [selectedSchools, setSelectedSchools] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Action Modal State
    const [actionModalVisible, setActionModalVisible] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [actionRemarks, setActionRemarks] = useState("");

    const handleActionClick = (action, id) => {
        setCurrentAction(action);
        setSelectedRowId(id);
        setActionRemarks("");
        setActionModalVisible(true);
    };

    const submitAction = async () => {
        if (!selectedRowId) return;

        setActionLoading(true);
        try {
            const payload = {
                status: currentAction,
                base_remarks: actionRemarks,
                base_date: new Date().toISOString().split('T')[0]
            };

            await axios.patch(apiurl + `basedataview/${selectedRowId}/`, payload);

            alert(`${currentAction} action submitted successfully!`);
            setActionModalVisible(false);
            fetchData();
        } catch (error) {
            console.error("Error submitting action:", error);
            alert("Failed to submit action.");
        } finally {
            setActionLoading(false);
        }
    };

    function convertToDDMMYYYY(timestamp) {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return year + "-" + month + "-" + day;
    }

    const handleDateChange = (dates) => {
        setDateRange(dates);
    };

    async function fetchData() {
        setLoading(true);
        try {
            const response = await axios.get(apiurl + `basedataview/`);
            setData(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    async function fetchStaff() {
        try {
            const res = await axios.get(apiurl + "staffdetails/?Role=Marketing&Status=Active&Staffid=");
            const res2 = await axios.get(apiurl + "Schoollistapi/");
            setSchoolList(res2.data);
            setStaffList(res.data);
        } catch (e) {
            console.error(e);
        }
    }

    async function fetchFilterData() {
        const sdate =
            dateRange && dateRange[0]
                ? convertToDDMMYYYY(dateRange[0].toString())
                : "";
        const edate =
            dateRange && dateRange[1]
                ? convertToDDMMYYYY(dateRange[1].toString())
                : "";

        setLoading(true);
        try {
            const response = await axios.get(
                apiurl +
                `basedataview/?assigned_to=${assignFilter?.value}`
            );
            setData(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
        fetchStaff();
    }, []);

    useEffect(() => {
        Tabhelper(
            {
                name: "Unassigned",
                link: "/unassigned",
                active: "no",
            },
            setJsonList
        );
    }, []);

    const openAssignModal = () => {
        setSelectedSchools([]);
        setSelectedStaff([]);
        setAssignPlan([]);
        setFilteredData([]);
        setUnassignedCount(0);
        setShowAssignModal(true);
    };

    const handleSchoolSelect = async (selectedOptions) => {
        setSelectedSchools(selectedOptions || []);

        if (!selectedOptions || selectedOptions.length === 0) {
            setFilteredData([]);
            setUnassignedCount(0);
            setAssignPlan([]);
            return;
        }

        const schoolNames = selectedOptions.map(s => s.label).join(",");

        try {
            const res = await axios.get(apiurl + `basedataview2/?unassigned=true&schools=${schoolNames}`);
            setFilteredData(res.data);
            setUnassignedCount(res.data.length);

            // Recalculate plan if staff are already selected
            if (selectedStaff.length > 0) {
                calculatePlan(selectedStaff, res.data.length);
            }
        } catch (error) {
            console.error("Error fetching filtered data:", error);
            setFilteredData([]);
            setUnassignedCount(0);
        }
    };

    const calculatePlan = (staff, totalCount) => {
        if (staff.length === 0) {
            setAssignPlan([]);
            return;
        }

        const total = totalCount;
        const per = Math.floor(total / staff.length);
        const extra = total % staff.length;
        console.log(staff)

        let plan = staff.map((s, i) => ({
            staff: s,
            count: i === staff.length - 1 ? per + extra : per,
            staffname: s,
        }));

        setAssignPlan(plan);
    };

    const handleStaffSelect = (checkedValues) => {
        setSelectedStaff(checkedValues);
        console.log(checkedValues);
        calculatePlan(checkedValues, unassignedCount);
    };

    const confirmAssign = async () => {
        const unassigned = filteredData;

        // Step 1: Prepare staff assignment list (flat)
        const staffAssignments = assignPlan.flatMap(row =>
            Array.from({ length: row.count }, () => row.staff)
        );

        // Step 2: Pair with unassigned
        const assignments = unassigned
            .slice(0, staffAssignments.length)
            .map((row, i) => ({
                id: row.id,
                assigned_to: staffAssignments[i],
            }));

        console.log(assignments);

        if (assignments.length === 0) {
            alert("No data to assign!");
            return;
        }

        try {
            const response = await axios.patch(apiurl + "bulkbasedata/", assignments);


            console.log("Updated Data:", response.data.updated_data);
            alert("Assigned successfully!");
            setShowAssignModal(false);
            fetchData();

        } catch (error) {
            console.error(error);
            alert("Bulk assign failed!");
        }
    };


    const Tablecomp = (props) => {
        const [rowdata, setRowdata] = useState([]);
        const [postsPerPage] = useState(5);
        const [currentPage, setCurrentPage] = useState(1);
        const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
        const [statusFilter, setStatusFilter] = useState('All');
        const [assignedToFilter, setAssignedToFilter] = useState('All');

        useEffect(() => {
            setRowdata(props.data.slice(0).reverse());
        }, [props.data]);

        const handleSort = (key) => {
            let direction = 'ascending';
            if (sortConfig.key === key && sortConfig.direction === 'ascending') {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
        };

        const sortedData = React.useMemo(() => {
            let sortableItems = [...rowdata];
            if (sortConfig.key) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [rowdata, sortConfig]);

        const filteredData = React.useMemo(() => {
            let data = sortedData;
            if (statusFilter !== 'All') {
                data = data.filter(item => item.status === statusFilter);
            }
            if (assignedToFilter !== 'All') {
                data = data.filter(item => item.assigned_to_name === assignedToFilter);
            }
            return data;
        }, [sortedData, statusFilter, assignedToFilter]);

        const indexOfLastPage = currentPage * postsPerPage;
        const indexOfFirstPage = indexOfLastPage - postsPerPage;
        const currentPosts = filteredData.slice(indexOfFirstPage, indexOfLastPage);

        const totalPosts = filteredData.length;

        const showPagination = () => {
            const pageNumbers = [];
            for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
                pageNumbers.push(i);
            }

            return (
                <nav>
                    <ul className="pagination">
                        {pageNumbers.map((number) => (
                            <li
                                key={number}
                                className={currentPage === number ? "page-item active" : "page-item"}
                            >
                                <button
                                    onClick={() => setCurrentPage(number)}
                                    className="page-link"
                                >
                                    {number}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            );
        };

        const getStatusBadge = (status) => {
            let color = '#5600f5ff';
            if (status === 'Lead') color = '#1890ff'; // Blue
            if (status === 'Prospect') color = '#52c41a'; // Green
            if (status === 'Followup') color = '#faad14'; // Orange
            if (status === 'Not Interested') color = '#f5222d'; // Red

            return (
                <span style={{
                    backgroundColor: color,
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px'
                }}>
                    {status || "Base"}
                </span>
            );
        };

        return (
            <div className="container">
                {loading ? (
                    <div style={{ textAlign: "center", padding: "50px" }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <table className="table align-items-center justify-content-center mb-0">
                        <thead>
                            <tr>
                                <th onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>S.No {sortConfig.key === 'id' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('district')} style={{ cursor: 'pointer' }}>District {sortConfig.key === 'district' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('school_id')} style={{ cursor: 'pointer' }}>School ID {sortConfig.key === 'school_id' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('school_name')} style={{ cursor: 'pointer' }}>School Name {sortConfig.key === 'school_name' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('student_name')} style={{ cursor: 'pointer' }}>Student Name {sortConfig.key === 'student_name' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('student_class')} style={{ cursor: 'pointer' }}>Class {sortConfig.key === 'student_class' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('gender')} style={{ cursor: 'pointer' }}>Gender {sortConfig.key === 'gender' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('phone_1')} style={{ cursor: 'pointer' }}>Phone {sortConfig.key === 'phone_1' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('entry_date')} style={{ cursor: 'pointer' }}>Entry Date {sortConfig.key === 'entry_date' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th>Source</th>

                                {user === "Super Admin" && <>
                                    <th>
                                        <select
                                            className="form-control"
                                            style={{ height: '30px', padding: '0 5px', fontSize: '12px' }}
                                            value={assignedToFilter}
                                            onChange={(e) => setAssignedToFilter(e.target.value)}
                                        >
                                            <option value="All">Assigned To (All)</option>
                                            {staffList.map((staff) => (
                                                <option key={staff.id} value={staff.Name}>
                                                    {staff.Name}
                                                </option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>
                                        <select
                                            className="form-control"
                                            style={{ height: '30px', padding: '0 5px', fontSize: '12px' }}
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                        >
                                            <option value="All">Status (All)</option>
                                            <option value="Lead">Lead</option>
                                            <option value="Prospect">Prospect</option>
                                            <option value="Followup">Followup</option>
                                        </select>
                                    </th></>}

                                {/* <th>Actions</th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {currentPosts.length === 0 ? (
                                <tr>
                                    <td colSpan="13" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                                        No data found
                                    </td>
                                </tr>
                            ) : (
                                currentPosts.map((item, index) => (
                                    <tr key={index}>
                                        <td>{postsPerPage * (currentPage - 1) + index + 1}</td>
                                        <td>{item.district || "-"}</td>
                                        <td>{item.school_id || "-"}</td>
                                        <td>{item.school_name || "-"}</td>
                                        <td>{item.student_name || "-"}</td>
                                        <td>{item.student_class || "-"}</td>
                                        <td>{item.gender || "-"}</td>
                                        <td>{item.phone_1 || "-"}</td>
                                        <td>{item.entry_date || "-"}</td>
                                        <td>{item.source || "-"}</td>
                                        {user === "Super Admin" && <>
                                            <td>{item.assigned_to_name || "-"}</td>
                                            <td>{getStatusBadge(item.status)}</td>
                                        </>}
                                            {/* <td>
                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                    <button className="btn btn-success btn-sm" style={{ fontSize: '10px', padding: '2px 5px' }} onClick={() => handleActionClick('Lead', item.id)}>Lead</button>
                                                    <button className="btn btn-danger btn-sm" style={{ fontSize: '10px', padding: '2px 5px' }} onClick={() => handleActionClick('Not Interested', item.id)}>X</button>
                                                </div>
                                            </td> */}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}

                <div style={{ float: "right" }}>{showPagination()}</div>
            </div>
        );
    };

    const [selectedStaffdp, setSelectedStaffdp] = useState(null);
    const handleStaffSelectdropdown = (selectedOption) => {
        setAssignFilter(selectedOption);

        // If you want to store only the ID in a separate state as well:
        // setAssignedTo(selectedOption?.value || null);
    };

    return (
        <Maincomponent tabname={"Unassigned"}>
            <div className="component-sub">
                <div className="component-sub1">
                    <div className="multistephead">
                        <b>UNASSIGNED</b>
                    </div>

                    <br />

                    {user === "Super Admin" && <>
                        <div className="Billcompmain">
                            <div className="Billcompmain2" style={{ width: "75%" }}>
                                <div className="multistepcontainer1">
                                    <div className="multistepsubcontainer1">
                                        <div className="multisteptable">

                                            <div className="multisteptablerow">
                                                <div className="multisteptablecell1">Assigned To</div>
                                                <div className="multisteptablecell2">
                                                    <Select
                                                        options={staffList.map((staff) => ({
                                                            label: staff.Name,
                                                            value: staff.id,
                                                        }))}
                                                        value={assignFilter}
                                                        onChange={handleStaffSelectdropdown}
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) => option.value}
                                                        placeholder="Select Assigned to"

                                                    />
                                                </div>
                                            </div>

                                            {/* <div className="multisteptablerow">
                                            <div className="multisteptablecell1">Entry Date</div>
                                            <div className="multisteptablecell2">
                                                <RangePicker onChange={handleDateChange} value={dateRange} />
                                            </div>
                                        </div> */}

                                            {/* <div className="multisteptablerow">
                                            <div className="multisteptablecell1">Status</div>
                                            <div className="multisteptablecell2">
                                                <Input
                                                    onChange={(e) => setStatusFilter(e.target.value)}
                                                    value={statusFilter}
                                                    type="text"
                                                    className="textipbill"
                                                />
                                            </div>
                                        </div> */}

                                        </div>
                                    </div>
                                </div>

                                <div className="multistepcontainerbtn">
                                    <button className="buttoncompnent1" onClick={fetchFilterData}>
                                        Find
                                    </button>

                                    <button
                                        className="buttoncompnent1"
                                        style={{ background: "#245953" }}
                                        onClick={openAssignModal}
                                    >
                                        Assign
                                    </button>
                                </div>
                            </div>
                        </div>

                        <br />
                        <br />
                    </>}


                    <div className="Billcompmain">
                        <Tablecomp data={data} />
                    </div>
                </div>
            </div>

            {/* ACTION MODAL */}
            <Modal
                title={`${currentAction} Action`}
                open={actionModalVisible}
                onCancel={() => setActionModalVisible(false)}
                onOk={submitAction}
                okText="Confirm"
                confirmLoading={actionLoading}
            >
                <p>Please enter remarks for {currentAction}:</p>
                <Input.TextArea
                    rows={4}
                    value={actionRemarks}
                    onChange={(e) => setActionRemarks(e.target.value)}
                    placeholder="Enter remarks here..."
                />
            </Modal>

            {/* ASSIGN MODAL */}
            <Modal
                title="Assign Data"
                open={showAssignModal}
                onCancel={() => setShowAssignModal(false)}
                footer={null}
                width={1000}

            >
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                    <h4>Assign Unassigned Data</h4>
                    <b>Total Unassigned (Filtered): {unassignedCount}</b>
                </div>

                <div style={{ display: "flex", gap: "20px" }}>
                    {/* Left Column: School Filter */}
                    <div style={{ flex: 1 }}>
                        <h5>Filter by School</h5>
                        <Select
                            options={schoolList}
                            isMulti
                            value={selectedSchools}
                            onChange={handleSchoolSelect}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            placeholder="Select Schools..."
                            className="basic-multi-select"
                            classNamePrefix="select"
                        />
                    </div>

                    {/* Right Column: Staff Selection */}
                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "20px" }}>
                        <h5>Select Staff</h5>
                        <Checkbox.Group
                            style={{ width: "100%", display: "flex", flexDirection: "column", gap: "8px" }}
                            onChange={handleStaffSelect}
                            value={selectedStaff}
                        >
                            {staffList.map((staff) => (
                                <Checkbox key={staff.Name} value={staff.id}>{staff.Name}</Checkbox>
                            ))}
                        </Checkbox.Group>
                    </div>
                </div>

                <hr style={{ margin: "20px 0" }} />

                {/* Bottom: Distribution Plan */}
                <div>
                    <h5>Distribution Plan</h5>
                    {assignPlan.length === 0 ? (
                        <p style={{ color: "#888" }}>Select schools and staff to see distribution.</p>
                    ) : (
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Staff</th>
                                    <th>Assigned Count</th>
                                </tr>
                            </thead>
                            <tbody>

                                {assignPlan.map((p) => (
                                    <tr key={p.staff}>

                                        <td>{p.staff}</td>
                                        <td>{p.count}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                <div style={{ textAlign: "right", marginTop: "20px" }}>
                    <button className="buttoncompnent1" onClick={confirmAssign} disabled={assignPlan.length === 0}>
                        Confirm Assign
                    </button>
                </div>
            </Modal>
        </Maincomponent>
    );
}
